module.exports = __webpack_public_path__ + "img/198-argentina.4987d1fb.svg";